import React, { useEffect, useState } from "react";

export default function CopyTextButton({ text }) {
  // idle | copying | success | error
  const [buttonStatus, setButtonStatus] = useState("idle");

  function handleClick() {
    setButtonStatus("copying");

    navigator.clipboard.writeText(text).then(
      () => {
        setButtonStatus("success");
      },
      () => {
        setButtonStatus("error");
      }
    );

    setTimeout(() => {
      setButtonStatus("idle");
    }, 2000);
  }

  return (
    <button
      className="button button--secondary button--s"
      onClick={handleClick}
      data-clipboard-text=""
    >
      {buttonStatus === "idle" && "Copy Text"}
      {(buttonStatus === "copying" || buttonStatus === "success") && "Text copied!"}
      {buttonStatus === "error" && "Error copying"}
    </button>
  );
}
